var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Header, Icon, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
var presetScalePageLinks = [
    {
        title: "Automated IF Preset Scales",
        description: "Automated Gold IF reagent preset scales.",
        path: AppPaths.ADMIN_AUTOMATED_IF_PRESET_SCALES
    },
    {
        title: "Pro Probe Preset Scales",
        description: "Pro RNA-ISH probe preset scales.",
        path: AppPaths.ADMIN_PRO_PROBE_PRESET_SCALES
    },
    {
        title: "Pro Detect Preset Scales",
        description: "Pro RNA-ISH detect reagent preset scales.",
        path: AppPaths.ADMIN_PRO_DETECT_PRESET_SCALES
    },
    {
        title: "Chromogen Preset Scales",
        description: "Pro RNA-ISH chromogen preset scales.",
        path: AppPaths.ADMIN_CHROMOGEN_PRESET_SCALES
    }
];
var PresetScalesPage = /** @class */ (function (_super) {
    __extends(PresetScalesPage, _super);
    function PresetScalesPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PresetScalesPage.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Preset Scales"),
            React.createElement("div", { id: "non-header-portion" },
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Preset Scale Page"),
                            React.createElement(Table.HeaderCell, null, "Description"),
                            React.createElement(Table.HeaderCell, null, "Open"))),
                    React.createElement(Table.Body, null, presetScalePageLinks.map(function (presetScalePageLink) { return (React.createElement(Table.Row, { key: presetScalePageLink.path },
                        React.createElement(Table.Cell, null,
                            React.createElement(Link, { to: presetScalePageLink.path }, presetScalePageLink.title)),
                        React.createElement(Table.Cell, null, presetScalePageLink.description),
                        React.createElement(Table.Cell, { collapsing: true },
                            React.createElement(Link, { to: presetScalePageLink.path },
                                React.createElement(Icon, { name: "arrow right" }),
                                "Open")))); }))))));
    };
    return PresetScalesPage;
}(React.PureComponent));
export default PresetScalesPage;
//# sourceMappingURL=PresetScalesPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/PresetScalesPage.js
// module id = 1477
// module chunks = 0